import styled from 'styled-components';
import { IconButton, IconButtonProps } from '../Button/IconButton';
import React, { useCallback } from 'react';

export type CopyButtonProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  size?: IconButtonProps['size'];
};

const StyledButton = styled(IconButton)`
  padding: 4px;
`;

export function CopyButton({
  value,
  className,
  size = 'sm',
  disabled = false,
  ...rest
}: CopyButtonProps) {
  const [copied, setCopied] = React.useState(false);
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2_000);
  }, [value]);

  return (
    <StyledButton
      {...rest}
      size={size}
      className={className}
      icon={copied ? 'other.copied' : 'other.copy'}
      onClick={handleCopy}
      disabled={disabled}
    />
  );
}

export const CopyIcon = styled(CopyButton).attrs({
  size: 'xs',
})`
  border: none;
  background: none;
  padding: 0;
  &:hover {
    opacity: 0.7;
    background: none;
  }
`;
